import { getStorageItem, setStorageItem, WebStorageType } from "../../../../common-deprecated/utils/storageUtils";
import type { ExternalConfigType } from "../../../shared-logic/types/ExternalPriceType";
import type { CommonSettingsType } from "../../../../common-deprecated/settings/fetchCommonSettings";

// ----------------------------------------------------------------------
// Helper Types and consts
// ----------------------------------------------------------------------
const LOCAL_STORAGE_ID = "onlineRetail.build";

type BuildLocalStorageParams = {
    country: string;
    language: string;
};

type BuildLocalStorageItemType = {
    external: {
        unfinishedConfigurations: ExternalConfigType[];
    };
};

// ----------------------------------------------------------------------
// Storage fns
// ----------------------------------------------------------------------
export const setBuildLocalStorage = (
    params: BuildLocalStorageParams,
    storageItems: BuildLocalStorageItemType,
): void => {
    setStorageItem({ ...params, storageId: LOCAL_STORAGE_ID }, storageItems, WebStorageType.local);
};

export const getBuildLocalStorage = (params: BuildLocalStorageParams): BuildLocalStorageItemType | null => {
    return getStorageItem({ ...params, storageId: LOCAL_STORAGE_ID }, WebStorageType.local);
};

/**
 * Sets an unfinished build configuration in the localStorage
 */
export const setUnfinishedConfiguration = (params: BuildLocalStorageParams, config: ExternalConfigType): void => {
    const existingConfigs = getBuildLocalStorage(params)?.external.unfinishedConfigurations || [];

    if (existingConfigs.find((oldConfig) => oldConfig.ModelID === config.ModelID)) {
        // Find the index of the object with the same model id
        const arrayIndex = existingConfigs.findIndex((oldConfig) => oldConfig.ModelID === config.ModelID);

        // Overwrite this index with the new configuration
        existingConfigs[arrayIndex] = config;
    } else if (existingConfigs.length === 2) {
        // Remove the first element of the array
        existingConfigs.shift();

        // Add new config to the end of the array
        existingConfigs.push(config);
    } else {
        existingConfigs.push(config);
    }

    setBuildLocalStorage(params, { external: { unfinishedConfigurations: existingConfigs } });
};

export const removeUnfinishedConfiguration = (params: BuildLocalStorageParams, modelId: string): void | null => {
    const existingConfigs = getBuildLocalStorage(params)?.external.unfinishedConfigurations;

    if (!existingConfigs) return;

    const newConfigs = existingConfigs.filter((oldConfig) => oldConfig.ModelID !== modelId);

    setBuildLocalStorage(params, { external: { unfinishedConfigurations: newConfigs } });
};

// ----------------------------------------------------------------------
// Helper fns
// ----------------------------------------------------------------------

export const getLocalStorageParams = (commonSettings: CommonSettingsType): BuildLocalStorageParams => ({
    country: commonSettings.country,
    language: commonSettings.language,
});
